import * as React from 'react';

export const SvgAssetSuccess = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 400 120" {...props}>
    <defs>
      <path id="asset-success_svg__a" d="M0 .551h400v119H0z" />
      <path
        id="asset-success_svg__b"
        d="M275.17 0l-101 101-62.864-62.865 15.927-15.927 46.938 46.937L243.316 0h31.855z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <use fill="#51CC85" xlinkHref="#asset-success_svg__a" />
      <use
        fill="#FFF"
        fillRule="nonzero"
        stroke="#FFF"
        strokeWidth={10}
        xlinkHref="#asset-success_svg__b"
      />
    </g>
  </svg>
);
